export const TaxSVG = ({ size = 18, fill = '#000000' }: { size?: number, fill?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 18 18" fill="none">
    <rect width="18" height="18" fill="white" fillOpacity="0.0901961" />
    <path
      d="M1.99945 4.4375C2.28189 5.19823 2.81879 5.77405 3.36688 6.18171"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.73123 6.73438H6.7334"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.052 8.351C11.9033 8.351 11.7827 8.23045 11.7827 8.08175C11.7827 7.93305 11.9033 7.8125 12.052 7.8125"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0513 8.351C12.2 8.351 12.3205 8.23045 12.3205 8.08175C12.3205 7.93305 12.2 7.8125 12.0513 7.8125"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6373 3.49652V5.45961C13.7115 6.03208 14.2833 6.89671 14.2833 8.30256L16 9.2679V11.1475C15.2261 12.0566 13.9358 12.7818 12.6373 13.2106V14.3789C12.6373 14.6763 12.3962 14.9174 12.0988 14.9174H10.3193C10.0219 14.9174 9.78076 14.6763 9.78076 14.3789V13.2106H6.24906V14.3789C6.24906 14.6763 6.00796 14.9174 5.71056 14.9174H3.73684C3.51854 14.9174 3.32122 14.7866 3.24358 14.5826C2.43078 12.4469 1.79356 9.2231 2.78912 7.16596C3.51268 5.67085 4.6916 3.94538 9.58588 4.72817C10.1235 3.40421 11.5365 3.04855 12.2769 3.07133C12.4983 3.07813 12.6373 3.27497 12.6373 3.49652Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)